import React, { useEffect, useState } from 'react';
import { useReframe } from 'nike-re-framejs';
import { context, sendRequest } from '../user-profile/handlers';
import { useFormSubmit } from '../user-profile/hooks/useForm';
import { makeForm, resetValue } from 'nike-form-js';
import { Map } from 'immutable';
import { TwoFactorProvider, useTwoFactorContext } from '../2fa/TwoFactorContext';
import { Switch } from '../forms/Switch';
import { servicesExtra$, start2FAWizard } from './h&s';

const ExtraServicesSmsSwitch2FA = () => (
    <TwoFactorProvider config={{ onStart2Fa: start2FAWizard }}>
        <ExtraServicesSmsSwitch />
    </TwoFactorProvider>
);

const SMS_PATH = ['flag_info_by_sms'];
function useForm(initialData, onSubmit) {
    const [form] = useState(() => {
        return makeForm(initialData);
    });
    return [form, useFormSubmit(form, onSubmit), resetValue];
}

function ExtraServicesSmsSwitch() {
    const { subscribe } = useReframe();
    const servicesExtra = subscribe(servicesExtra$());
    context.twoFactorContext = useTwoFactorContext();
    const [state, setState] = useState(servicesExtra);
    useEffect(() => setState(servicesExtra), [servicesExtra]);
    const initialData = Map().setIn(SMS_PATH, servicesExtra ? !servicesExtra : true);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [form, onSubmit] = useForm(initialData, onSubmitHandler);
    const onToggle = e => {
        setState(!state);
        onSubmit(e);
    };
    function onSubmitHandler(formValues, form) {
        const changeEntry = {
            parameter: 'flag_info_by_sms',
            currentValue: servicesExtra ? 1 : 0,
            newValue: !servicesExtra ? 1 : 0
        };
        sendRequest([changeEntry], form, () => false);
    }
    if (servicesExtra === undefined) return null;
    return <Switch active={state} throttlingDelay={1200} onClick={e => onToggle(e)} dataAtid="extraServices" />;
}

export default ExtraServicesSmsSwitch2FA;
